/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown>, price: NonNullable<unknown> }} Admin_Billing_Bills_List_Detail_MessagesInputs */

const es_admin_billing_bills_list_detail_messages = /** @type {(inputs: Admin_Billing_Bills_List_Detail_MessagesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} msg × ${i?.price}`)
};

const en_admin_billing_bills_list_detail_messages = /** @type {(inputs: Admin_Billing_Bills_List_Detail_MessagesInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} msg × ${i?.price}`)
};

/**
* | output |
* | --- |
* | "{count} msg × {price}" |
*
* @param {Admin_Billing_Bills_List_Detail_MessagesInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const admin_billing_bills_list_detail_messages = /** @type {((inputs: Admin_Billing_Bills_List_Detail_MessagesInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Billing_Bills_List_Detail_MessagesInputs, { locale?: "es" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_admin_billing_bills_list_detail_messages(inputs)
	return en_admin_billing_bills_list_detail_messages(inputs)
});
export { admin_billing_bills_list_detail_messages as "admin.billing.bills_list.detail_messages" }